var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 32,
    rx: 4,
    transform: "matrix(-1 0 0 1 15 8)",
    fill: "#039BE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9C17 8.44772 17.4477 8 18 8H40C40.5523 8 41 8.44772 41 9V39C41 39.5523 40.5523 40 40 40H18C17.4477 40 17 39.5523 17 39V9ZM21 13C21 12.4477 21.4477 12 22 12H36C36.5523 12 37 12.4477 37 13V17C37 17.5523 36.5523 18 36 18H22C21.4477 18 21 17.5523 21 17V13ZM22 20C21.4477 20 21 20.4477 21 21V23C21 23.5523 21.4477 24 22 24H24C24.5523 24 25 23.5523 25 23V21C25 20.4477 24.5523 20 24 20H22ZM27 21C27 20.4477 27.4477 20 28 20H30C30.5523 20 31 20.4477 31 21V23C31 23.5523 30.5523 24 30 24H28C27.4477 24 27 23.5523 27 23V21ZM34 20C33.4477 20 33 20.4477 33 21V23C33 23.5523 33.4477 24 34 24H36C36.5523 24 37 23.5523 37 23V21C37 20.4477 36.5523 20 36 20H34ZM21 27C21 26.4477 21.4477 26 22 26H24C24.5523 26 25 26.4477 25 27V29C25 29.5523 24.5523 30 24 30H22C21.4477 30 21 29.5523 21 29V27ZM28 26C27.4477 26 27 26.4477 27 27V29C27 29.5523 27.4477 30 28 30H30C30.5523 30 31 29.5523 31 29V27C31 26.4477 30.5523 26 30 26H28ZM33 27C33 26.4477 33.4477 26 34 26H36C36.5523 26 37 26.4477 37 27V29C37 29.5523 36.5523 30 36 30H34C33.4477 30 33 29.5523 33 29V27ZM22 32C21.4477 32 21 32.4477 21 33V35C21 35.5523 21.4477 36 22 36H24C24.5523 36 25 35.5523 25 35V33C25 32.4477 24.5523 32 24 32H22ZM27 33C27 32.4477 27.4477 32 28 32H30C30.5523 32 31 32.4477 31 33V35C31 35.5523 30.5523 36 30 36H28C27.4477 36 27 35.5523 27 35V33ZM34 32C33.4477 32 33 32.4477 33 33V35C33 35.5523 33.4477 36 34 36H36C36.5523 36 37 35.5523 37 35V33C37 32.4477 36.5523 32 36 32H34Z",
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default ForwardRef;